import { Col, Container, Row } from 'react-bootstrap';
import edit from '../../../../../../../../assets/images/icons/edit.svg';
import trash from '../../../../../../../../assets/images/icons/trash.svg';
import floatToCurrency from '../../../../../../../../utils/floatToCurrency';
import OpacityAnimation from '../../../../../../../OpacityAnimation';
import { ListaItensVt, TrajetoInstruc } from '../../../../types';
import {
  Card,
} from './styles';

interface IListInterface {
  instructions: TrajetoInstruc[];
  handleOpenDeleteModal: (instruction: TrajetoInstruc) => void;
  handleOpenEditModal: (instruction: TrajetoInstruc) => void;
  vtItensOptions: ListaItensVt[];
  manualRoutingType: 'detailed' | 'simple';
}

export default function List({
  instructions,
  vtItensOptions,
  handleOpenDeleteModal,
  handleOpenEditModal,
  manualRoutingType,
}: IListInterface) {
  const findCorrespondingVtItem = (vtItemCode: number) => (
    vtItensOptions.find((vt) => vt.codItem === vtItemCode)
  );

  return (
    <Container>
      <Row xs={1} md={2} lg={manualRoutingType === 'detailed' ? 2 : 3}>
        {manualRoutingType === 'detailed' && (
          <>
            {instructions?.map((instruction) => (
              <Col key={`${instruction.instrucao}${instruction.codItem}${instruction.codSentido}${instruction.sequencia}`}>
                <OpacityAnimation delay={0.1}>
                  <Card>
                    <div className="info">
                      <div className="card-title">
                        <strong>{instruction.instrucao}</strong>
                        <small>
                          #{instruction.sequencia}
                        </small>
                      </div>
                      <span>
                        De:
                        {' '}
                        {instruction.origem}
                      </span>
                      <span>
                        Até:
                        {' '}
                        {instruction.destino}
                      </span>
                      <span>
                        VT:
                        {' '}
                        {
                          instruction.codItem
                            ? (`${findCorrespondingVtItem(instruction.codItem)?.descricao} - ${findCorrespondingVtItem(instruction.codItem)?.codGeo} (${floatToCurrency(findCorrespondingVtItem(instruction.codItem)?.tarifa ?? 0)})`)
                            : 'Instrução não conta com VT'
                        }
                      </span>
                      <span>
                        Linha:
                        {' '}
                        {instruction.linhaTransp || 'Instrução não conta com Linha'}
                      </span>
                    </div>

                    <div className="actions">
                      <button
                        type="button"
                        onClick={() => handleOpenDeleteModal(instruction)}
                      >
                        <img src={trash} alt="trash" title="Remover instrução" />
                      </button>

                      <button onClick={() => handleOpenEditModal(instruction)}>
                        <img src={edit} alt="edit" title="Editar instrução" className="primaryColor" />
                      </button>
                    </div>
                  </Card>
                </OpacityAnimation>
              </Col>
            ))}
          </>
        )}

        {manualRoutingType === 'simple' && (
          <>
            {instructions?.map((instruction) => (
              <Col key={`${instruction.instrucao}${instruction.codItem}${instruction.codSentido}${instruction.sequencia}`}>
                <OpacityAnimation delay={0.1}>
                  <Card>
                    <div className="info">
                      <div className="card-title">
                        <strong>{findCorrespondingVtItem(instruction.codItem)?.descricao}</strong>
                        <small>
                          #{instruction.sequencia}
                        </small>
                      </div>
                      <span>
                        Tarifa:
                        {' '}
                        {floatToCurrency(findCorrespondingVtItem(instruction.codItem)?.tarifa ?? 0)}
                      </span>
                      <span>
                        Código Item:
                        {' '}
                        {findCorrespondingVtItem(instruction.codItem)?.codItem}
                      </span>
                      <span>
                        Código GEO:
                        {' '}
                        {findCorrespondingVtItem(instruction.codItem)?.codGeo}
                      </span>
                    </div>

                    <div className="actions">
                      <button
                        type="button"
                        onClick={() => handleOpenDeleteModal(instruction)}
                      >
                        <img src={trash} alt="trash" title="Remover instrução" />
                      </button>

                      <button onClick={() => handleOpenEditModal(instruction)}>
                        <img src={edit} alt="edit" title="Editar instrução" className="primaryColor" />
                      </button>
                    </div>
                  </Card>
                </OpacityAnimation>
              </Col>
            ))}
          </>
        )}
      </Row>
    </Container>
  );
}
